/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerGetRegionsQueryResponse,
  TelegramGeoControllerGetRegionsPathParams,
} from '../../types/TelegramGeoControllerGetRegions.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetRegions } from '../../methods/telegramGeoGetRegions.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetRegionsQueryKey = (countryId: TelegramGeoControllerGetRegionsPathParams['countryId']) =>
  [{ url: '/api/telegram/geo/regions/:countryId', params: { countryId: countryId } }] as const;

export type TelegramGeoGetRegionsQueryKey = ReturnType<typeof telegramGeoGetRegionsQueryKey>;

export function telegramGeoGetRegionsQueryOptions(
  countryId: TelegramGeoControllerGetRegionsPathParams['countryId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetRegionsQueryKey(countryId);
  return queryOptions<
    TelegramGeoControllerGetRegionsQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetRegionsQueryResponse,
    typeof queryKey
  >({
    enabled: !!countryId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetRegions(countryId, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/regions/:countryId}
 */
export function useTelegramGeoGetRegions<
  TData = TelegramGeoControllerGetRegionsQueryResponse,
  TQueryData = TelegramGeoControllerGetRegionsQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetRegionsQueryKey,
>(
  countryId: TelegramGeoControllerGetRegionsPathParams['countryId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetRegionsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetRegionsQueryKey(countryId);

  const query = useQuery(
    {
      ...telegramGeoGetRegionsQueryOptions(countryId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
